import { Component, Input } from '@angular/core';
import { ConversationHeaderData } from './conversation-header.interface';
import { RESOLUTION_TYPES } from '../resolution-types';

@Component({
  selector: 'app-voice-ai-conversation-header',
  templateUrl: './conversation-header.component.html',
  styleUrls: ['./conversation-header.component.scss'],
})
export class ConversationHeaderComponent {
  @Input() set headerData(value: ConversationHeaderData) {
    this._headerData = value;
    this.showAllCategories = false;
  }
  get headerData(): ConversationHeaderData {
    return this._headerData;
  }
  private _headerData: ConversationHeaderData;

  showAllCategories = false;

  public get resolutionName(): string {
    const resolution = RESOLUTION_TYPES.find(r => r.id === this._headerData?.resolution);
    return resolution?.name || '';
  }

  toggleSeeMore(): void {
    this.showAllCategories = !this.showAllCategories;
  }

  trackByCategory(_index: number, category: string): string {
    return category;
  }
}
